<template>
  <b-col class="m-auto">
    <slot name="logo"></slot>
    <h4 class="text-muted pb-4" v-if="!loading">
      {{ resources.page.login.password.resetTitle }}
    </h4>
    <div v-if="loading" class="loading">
      <loading />
      <p>{{ resources.page.login.new.confirmEmailPage.loading }}</p>
    </div>
    <b-form v-else @submit.prevent="resetPassword" ref="form">
      <CustomInput
        type="password"
        hasPasswordConfirm="true"
        :passwordRules="passwordRules"
        :title="resources.general.input.password"
        :label="resources.general.input.password"
        :labelWrong="resources.general.input.password"
        :confirmTitle="resources.general.input.passwordConfirmWarning"
        :confirmLabel="resources.general.input.passwordConfirm"
        :confirmLabelWrong="resources.general.input.passwordConfirmWrong"
        v-on:update="updatePassword($event.value)"
      >
      </CustomInput>

      <div
        v-if="password.message"
        align-h="center"
        class="pl-3 pr-3 pb-3 error-message"
      >
        <span id="exception-message" class="text-secondary text-center">
          {{ password.message }}
        </span>
      </div>

      <Recaptcha ref="recaptcha" @verify="recaptchaVerify">
        <b-button
          id="btn-reset"
          :disabled="submitInProgress"
          type="submit"
          variant="quartenary"
          class="col-12 mb-3 mt-1"
        >
          <i
            class="mdi mdi-spin pr-2"
            v-bind:class="{ 'mdi-loading': submitInProgress }"
          ></i>
          {{ resources.general.buttons.reset }}
        </b-button>
      </Recaptcha>
    </b-form>

    <b-row align-h="center" class="mb-3" v-if="!loading">
      <b-col>
        <b-link id="backToLogin" :to="{ name: 'login.auth' }">
          {{ resources.page.login.new.returnToLogin }}
        </b-link>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import { mapGetters } from 'vuex'
import { getUser } from '@/service/user'
import ability from '@/helpers/ability'
import CustomInput from '../../components/Shared/Form/CustomInput.vue'
import Recaptcha from '@/components/Shared/Recaptcha.vue'
import auth from '@/mixins/auth'
import Loading from '@/components/Shared/Loading.vue'

export default {
  components: {
    CustomInput,
    Recaptcha,
    Loading,
  },

  data() {
    return {
      loading: false,
      passwordRules: undefined,
      submitInProgress: false,
      googleRecaptcha: undefined,
    }
  },

  computed: {
    ...mapGetters('password', {
      password: 'password',
    }),

    ...mapGetters({
      resources: 'resources',
    }),

    getEmail() {
      return this.$route.query.email
        ? decodeURIComponent(this.$route.query.email)
        : undefined
    },

    getRefer() {
      return this.$route.query.ref ? this.$route.query.ref : '/dashboard'
    },

    dataFormated() {
      return {
        token: this.$route.params.token,
        email: this.getEmail,
        googleRecaptcha: this.googleRecaptcha,
      }
    },
  },

  mounted: function() {
    this.$nextTick(() => {
      const { token } = this.$route.params

      this.loading = true
      this.$store
        .dispatch('user/loadPasswordRules', { token, action: 'new-password' })
        .then(({ data: { passwordRules } }) => {
          this.passwordRules = passwordRules
          this.loading = false
        })
        .catch(error => {
          this.$store.commit(
            'password/updateMessage',
            error.response.data.message
          )
          this.loading = false
        })
    })
  },
  methods: {
    updatePassword(password) {
      this.$store.commit('password/updatePassword', password)
    },

    recaptchaVerify(value) {
      this.googleRecaptcha = value
      this._doResetPassword()
    },

    resetPassword() {
      if (this.submitInProgress) return
      localStorage.setItem('redirectAfterLogin', this.getRefer)

      if (!this.$refs.form.checkValidity()) {
        this.$refs.form.reportValidity()
        this.resetRecaptcha()
        return false
      }

      this.$refs.recaptcha.execute()
    },

    _doResetPassword() {

      this.submitInProgress = true
      this.$store.commit('password/updateMessage', null)
      this.$store
        .dispatch('password/resetPassword', this.dataFormated)
        .then(response => {
          if (this.getEmail) {
            this.$store.dispatch('user/saveUserData', response)
            this.$root.$emit('login', getUser())
            this.$ability.update(ability().rules)
            auth.redirect()
          } else {
            this.$router.push({ name: 'login.password.success' })
          }
          this.submitInProgress = false
        })
        .catch(error => {
          this.$store.commit(
            'password/updateMessage',
            error.response.data.message
          )
          this.submitInProgress = false
        })
    },
    resetRecaptcha() {
      this.$refs.recaptcha.resetRecaptcha()
    },
  },
}
</script>

<style scoped lang="scss">
.loading {
  margin: 0 auto;
  text-align: center;
}

/deep/ .custom-input-label {
  font-size: 12px;
  top: -18px;
}

/deep/ .password-strength-indicator {
  margin-bottom: 30px !important;
}
</style>
